"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Stacks 2.0 Blockchain API
 * This is the documentation for the Stacks 2.0 Blockchain API.  It is comprised of two parts; the Stacks Blockchain API and the Stacks Core API.  <a href=\"collection.json\" download=\"collection.json\">Download Postman collection</a>
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.ReadOnlyFunctionSuccessResponseToJSON = exports.ReadOnlyFunctionSuccessResponseFromJSONTyped = exports.ReadOnlyFunctionSuccessResponseFromJSON = void 0;
const runtime_1 = require("../runtime");
function ReadOnlyFunctionSuccessResponseFromJSON(json) {
    return ReadOnlyFunctionSuccessResponseFromJSONTyped(json, false);
}
exports.ReadOnlyFunctionSuccessResponseFromJSON = ReadOnlyFunctionSuccessResponseFromJSON;
function ReadOnlyFunctionSuccessResponseFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'okay': json['okay'],
        'result': !runtime_1.exists(json, 'result') ? undefined : json['result'],
        'cause': !runtime_1.exists(json, 'cause') ? undefined : json['cause'],
    };
}
exports.ReadOnlyFunctionSuccessResponseFromJSONTyped = ReadOnlyFunctionSuccessResponseFromJSONTyped;
function ReadOnlyFunctionSuccessResponseToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'okay': value.okay,
        'result': value.result,
        'cause': value.cause,
    };
}
exports.ReadOnlyFunctionSuccessResponseToJSON = ReadOnlyFunctionSuccessResponseToJSON;
//# sourceMappingURL=ReadOnlyFunctionSuccessResponse.js.map